'use client';

import { IRepository } from '@/types';
import { IEvaluation } from '@/lib/evaluationsApi';
import * as Styled from './styled';
import Link from 'next/link';
import EvaluationCard from './EvaluationCard';
import Flash from '@/ui/Flash';

const EvaluationsList: React.FC<{
  repository: IRepository;
  evaluations: IEvaluation[];
  compressed?: boolean;
  sectionNavigationPath: string;
}> = ({ repository, evaluations, compressed, sectionNavigationPath }) => {
  const sortedEvaluations = evaluations?.sort((a, b) => b.inserted_at.localeCompare(a.inserted_at));
  return (
    <Styled.EvaluationsList compressed={compressed}>
      {sortedEvaluations?.length! ? (
        sortedEvaluations.map((evaluation: IEvaluation) => (
          <EvaluationCard
            key={evaluation.id}
            evaluation={evaluation}
            repository={repository}
            sectionNavigationPath={sectionNavigationPath}
          />
        ))
      ) : (
        <Flash.Info center>
          <b>
            There haven't been any evaluations created for this repository yet -{' '}
            <Link className="link-underline" href={`/${repository.namespace}/${repository.name}/evaluations/new`}>
              create your first!
            </Link>
          </b>
        </Flash.Info>
      )}
    </Styled.EvaluationsList>
  );
};

export default EvaluationsList;
